import { render } from "./Tooltips.vue?vue&type=template&id=4c2a130f&ts=true"
import script from "./Tooltips.vue?vue&type=script&lang=ts"
export * from "./Tooltips.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__